/**
 * @generated SignedSource<<4e6cd82bdce335aed5fce6c33651f1fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type genericArticleFooterItemArticle$data = {
  readonly images: ReadonlyArray<{
    readonly isSlideshow: boolean | null;
    readonly title: string | null;
    readonly url: string;
  } | null> | null;
  readonly updatedDate: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"contentHeadlineContent" | "entityLink">;
  readonly " $fragmentType": "genericArticleFooterItemArticle";
};
export type genericArticleFooterItemArticle$key = {
  readonly " $data"?: genericArticleFooterItemArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericArticleFooterItemArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "genericArticleFooterItemArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineContent"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSlideshow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "da1996ed264136262270c9245d02adb1";

export default node;
